import { IConfigService } from '../config';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';

export abstract class BaseProcessingMetricsService implements IService {
  protected resourceWrapperService: ResourceWrapperService;
  protected projectMetricsByExtension: any;
  protected projectMetricsByType: any;
  protected collectionMetricsByExtension: any;
  protected collectionMetricsByType: any;
  private configService: IConfigService;

  protected constructor($resource: angular.resource.IResourceService, configService: IConfigService, resourceWrapperService: ResourceWrapperService) {
    this.configService = configService;
    this.resourceWrapperService = resourceWrapperService;
  }

  public async GetExtensionByCount(projectId: string, collectionId?: string) {
    if (collectionId) {
      return this.collectionMetricsByExtension.count.query({
        id: projectId,
        collectionId: collectionId
      });
    }

    return this.projectMetricsByExtension.count.query({id: projectId});
  }

  public async GetExtensionBySize(projectId: string, collectionId?: string) {
    if (collectionId) {
      return this.collectionMetricsByExtension.size.query({
        id: projectId,
        collectionId: collectionId
      });
    }

    return this.projectMetricsByExtension.size.query({id: projectId});
  }

  public async GetTypeByCount(projectId: string, collectionId?: string) {
    if (collectionId) {
      return this.collectionMetricsByType.count.query({id: projectId, collectionId: collectionId});
    }

    return this.projectMetricsByType.count.query({id: projectId});
  }

  public async GetTypeBySize(projectId: string, collectionId?: string) {
    if (collectionId) {
      return this.collectionMetricsByType.size.query({id: projectId, collectionId: collectionId});
    }

    return this.projectMetricsByType.size.query({id: projectId});
  }
}
